var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup206(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 573,
    height: 189,
    viewBox: "0 0 573 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48242 186.5L81.0291 176H127.557L150.019 170.5L170.342 156.5L214.73 97L231.844 63L286.929 74.5L327.574 117.5H354.314H416.887L477.854 84L522.243 4L571.445 97",
    stroke: "#DEDEDE",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34375 187L67.6595 141.5L100.283 150L138.254 159L176.225 131L201.896 112L240.936 104.5L268.211 89.5H344.154H422.77L445.767 64H485.342L536.683 49L566.632 26",
    stroke: "url(#paint0_linear_9461_18231)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9461_18231",
    x1: 1.34375,
    y1: 106.5,
    x2: 566.632,
    y2: 106.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28AA4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup206);
export default __webpack_public_path__ + "static/media/Group 206.d66fd767c92080601f127cdbc195259f.svg";
export { ForwardRef as ReactComponent };